export const config = {
  baseUrl: process.env.REACT_APP_IB_BASE_URL ?? "",
  baseApiUrl: process.env.REACT_APP_IB_API_BASE_URL ?? "",
  token: process.env.REACT_APP_IB_TOKEN ?? "",
  apiVersion: process.env.REACT_APP_API_VERSION ?? "",
  appPlatform: process.env.REACT_APP_PLATFORM,
  minBackendVersion: "1.8.12_5",
  baseImageUrl:
    "https://s3-eu-west-1.amazonaws.com/gol-data-fr-ireland/instabook/",
  routes: {
    base: "/instabook/bookings",
    url: [
      "/instabook/bookings/:bookingId(\\d+)/update_from_email",
      "/instabook/bookings/:version(v3)?/:restaurantId(\\d+)/:referralKey",
      "/instabook/bookings/:version(v3)?/:referralKey",
    ],
    selection: "selection",
    commercials: "commercials",
    confirmation: "confirmation",
    confirmationOnRefresh: "confirmation/refresh",
    confirmationEnd: "confirmation/sharing",
    floatingButton: "/instabook/cta/:referralKey",
    newsletter: "/instabook/newsletter/:referralKey",
  },
  default_language: process.env.REACT_APP_DEFAULT_LOCALE ?? "",
};
